import {useCallback} from 'react'
import {useIntl} from 'react-intl'
// @ts-ignore
import {useHistory, useLocation} from 'react-router-dom'

/**
 * A convenience hook for programmatic navigation uses history's `push` or `replace`. The proper locale
 * is automatically prepended to the provided path. Additional args are passed through to `history`.
 */
const useNavigation = () => {
  const history = useHistory()
  const {locale} = useIntl()
  const currentLocation = useLocation<Record<string, unknown>>()

  return useCallback(
    /**
     *
     * @param {string} path - path to navigate to
     * @param {('push'|'replace')} action - which history method to use
     * @param  {...any} args - additional args passed to `.push` or `.replace`
     */
    (path: string, action = 'push', ...args: any) => {
      // const localePath = `/${locale}`
      const localePath = `/`
      const localizedHref = path && path?.includes(localePath) ? path : `${localePath}${path}`
      const location = path === '/' ? '/' : localizedHref

      // Carry the current location's state forward through chained navigations (e.g. delivery
      // type/address selection pages) so keys like originPath/redirectTo aren't lost. Any state
      // explicitly passed to this call takes priority over the carried-forward values.
      const currentState = currentLocation?.state
      if (currentState && typeof currentState === 'object') {
        args[0] = {...currentState, ...(typeof args[0] === 'object' ? args[0] : {})}
      }

      action === 'push'
        ? history.push(location, ...args)
        : history.replace(location, ...args)
      
    },
    [locale, currentLocation?.state]
  )
}

export default useNavigation
